<template lang="pug">
  span
    el-card.box-card.bg-purple
      .clearfix(slot="header")
        | Αναζήτηση Αιτήσεων:
        el-button(style='float: right; padding: 3px 0', type='text', @click='toggleSearch')| Κλείσιμο
      .text.item
        el-input(placeholder='Επώνυμο',
          type="text",
          v-model='searchSurname',
          v-on:keyup.enter.native='searchApps')
        el-input(placeholder='Όνομα',
          type="text",
          v-model='searchFirstname',
          v-on:keyup.enter.native='searchApps')
        el-input(placeholder='ΑΦΜ',
          v-model='searchAfm',
          v-on:keyup.enter.native='searchApps',
          maxlength="9",
          show-word-limit)
        el-input(placeholder='Αρ. Πρωτοκόλλου', v-model='searchProtocolNum',
          v-on:keyup.enter.native='searchApps', suffix-icon="el-icon-search")
        el-input(placeholder='Αρ. Πράξης', v-model='searchActNum',
          v-on:keyup.enter.native='searchApps', suffix-icon="el-icon-search")
        el-input(placeholder='Αρ. Αίτησης', v-model.number='searchAppNum',
          v-on:keyup.enter.native='searchApps', suffix-icon="el-icon-search")
        el-date-picker(v-model="searchBirthdate", type="date", placeholder="Ημ. Γέννησης",
          format="dd-MM-yyyy", value-format="dd-MM-yyyy", v-on:keyup.enter.native='searchApps')
        el-tooltip(placement='right')
          div(slot='content')
            | Επώνυμο: Τουλάχιστον 2 ελληνικούς ή 4 αγγλικούς χαρακτήρες
            br
            | Όνομα: Αναζήτηση τύπου "αρχίζει με"
            br
            | ΑΦΜ: 9 ψηφία
            br
            | Αρ. Πρωτ.: π.χ. Α/21-2019 , όπου Α ελληνικά. Δυνατότητα αναζήτησης με %
            br
            | Αρ. Πράξης: π.χ. Η25.3ΕΜ18/2019 , όπου H αγγλικά, Ε/Β/Δ/Μ ελληνικά. Δυνατότητα αναζήτησης με %
            br
            | Αρ. Αίτησης: Αριθμός καταχώρησης αίτησης
            br
            | Ημ. Γέννησης: Αναζήτηση μόνο με ημέρα-μήνα, όχι έτος γέννησης
          i.el-icon-question
        hr
        el-select.big(v-model='searchStatus', placeholder='Στάδιο Αίτησης',
          filterable, clearable, v-on:keyup.enter.native='searchApps' @change='handleSearchPage')
          el-option(v-for='appState in appStates', :key='appState.id', :label='appState.gr_name', :value='appState.name')
        el-select.big(v-model='searchRole', placeholder='Ρόλος', filterable, clearable,
          @keyup.enter.native='searchApps', @focus='getRoles', v-loading='gettingRoles')
          el-option(v-for='role in roles', :key='role.id',
            :label='role.gr_name', :value='role.id')
        el-select.big(v-model='searchDecision', placeholder='Απόφαση Προέδρου',
          filterable, clearable, @keyup.enter.native='searchApps', @focus='getDecisions', v-loading='loadingPresidentDecisions')
          el-option(v-for='decision in presidentDecisions', :key='decision.id',
            :label='decision.decision_text', :value='decision.id')
        el-select.big(v-model='searchType', placeholder='Τύπος Αίτησης',
          filterable, clearable, v-on:keyup.enter.native='searchApps')
          el-option(v-for='appType in appTypes', :key='appType.id', :label='appType.name', :value='appType.id')
        el-select.big(v-model='searchModeOfStudy', placeholder='Τύπος Φοίτησης',
          filterable, clearable, v-on:keyup.enter.native='searchApps')
          el-option(v-for='appStudyMode in appDistanceLearning', :key='appStudyMode.val', :label='appStudyMode.desc', :value='appStudyMode.val')
        el-select.big(v-model='searchSubmissionStatus', placeholder='Κατάσταση υποβολής',
          filterable, clearable, v-on:keyup.enter.native='searchApps')
          el-option(v-for='reappSubmissionStatus in reappSubmissionStatuses', :key='reappSubmissionStatus.val', :label='reappSubmissionStatus.desc', :value='reappSubmissionStatus.val')
        el-select.big(v-model='searchCompensatoryMeasures', placeholder='Αντισταθμιστικά μέτρα (Συμπληρωματικές εξετάσεις)',
          filterable, clearable, v-on:keyup.enter.native='searchApps')
          el-option(v-for='compensatoryMeasuresType in compensatoryMeasuresTypes', :key='compensatoryMeasuresType.val', :label='compensatoryMeasuresType.desc', :value='compensatoryMeasuresType.val')
        el-tooltip(placement='right')
          div(slot='content')
            | Στάδιο Αίτησης/Απόφαση Προέδρου/Τύπος Αίτησης/Τύπος φοίτησης/
            br
            | Κατάσταση υποβολής/Αντισταθμιστικά μέτρα: Αναζήτηση στο γενικό σύνολο των αιτήσεων
            br
            | Ρόλος: Αναζήτηση στο σύνολο των αιτήσεων που έχετε διεκπεραιώσει από τον κάθε ρόλο σας
          i.el-icon-question
        hr
        el-select.countries(v-model='searchCountry', placeholder='Χώρα', @change="countrySelected",
          filterable, clearable, v-on:keyup.enter.native='searchApps')
          el-option(v-for='country in countries', :key='country.id', :label='country.name', :value='country.id')
        el-select.big(v-model='searchUniversity' , @change="universitySelected", v-loading='gettingUniversities'
          placeholder='Πανεπιστήμια', :disabled="disableUniversity", filterable, clearable,
          v-on:keyup.enter.native='searchApps')
          el-option(v-for="university in universities", :key="university.id",
            :label="university.name", :value="university.id")
            | {{university.name}}
        el-select.big(v-model='searchCollege' , @change="collegeSelected",
          placeholder='Κολλέγια', :disabled="disableCollege", filterable, clearable,
          v-on:keyup.enter.native='searchApps')
          el-option(v-for="college in colleges", :key="college.id",
            :label="college.name", :value="college.id")
            | {{college.name}}
        el-select.big(v-model='searchFaculty' , @change="facultySelected",
          placeholder='Σχολές', :disabled="disableFaculty", filterable, clearable,
          v-on:keyup.enter.native='searchApps')
          el-option(v-for="faculty in faculties", :key="faculty.id",
            :label="faculty.name", :value="faculty.id")
            | {{faculty.name}}
        el-select.big(v-model='searchDepartment',
          placeholder='Τμήματα', :disabled="disableDepartment", filterable, clearable,
          v-on:keyup.enter.native='searchApps')
          el-option(v-for="department in departments", :key="department.id",
            :label="department.name", :value="department.id")
            | {{department.name}}
        el-tooltip(placement='right')
          div(slot='content')
            | Αναζήτηση βάσει τους ιδρύματος του πτυχίου προς αναγνώριση
          i.el-icon-question
        hr
        el-date-picker(v-model="searchActDateFrom", type="date", placeholder="Πράξεις από...",
          format="dd-MM-yyyy", value-format="dd-MM-yyyy", v-on:keyup.enter.native='searchApps')
        el-date-picker(v-model="searchActDateTo", type="date", placeholder="...Πράξεις έως",
          format="dd-MM-yyyy", value-format="dd-MM-yyyy", v-on:keyup.enter.native='searchApps')
        el-tooltip(placement='right')
          div(slot='content')
            | Ημερομηνία ολοκλήρωσης της αναγνώρισης (ψηφιακής
            br
            | υπογραφής του εγγράφου) από τον πρόεδρο [από...έως]
          i.el-icon-question
        hr
        el-date-picker(v-model="searchSubmitDateFrom", type="date", placeholder="Υποβληθείσες από...",
          format="dd-MM-yyyy", value-format="dd-MM-yyyy", v-on:keyup.enter.native='searchApps')
        el-date-picker(v-model="searchSubmitDateTo", type="date", placeholder="...Υποβληθείσες έως",
          format="dd-MM-yyyy", value-format="dd-MM-yyyy", v-on:keyup.enter.native='searchApps')
        el-tooltip(placement='right')
          div(slot='content')
            | Ημερομηνία πρώτης οριστικής υποβολής
            br
            | της αίτησης από τον πολίτη [από...έως]
          i.el-icon-question
        el-button(type='primary', @click="searchApps", v-popover:popover="" class='searchButton') Αναζήτηση Αιτήσεων
        p Πλήθος αιτήσεων: {{ countSearchedApps}}
        el-switch(v-model="showFilters", active-text="Εμφάνιση στηλών", inactive-text="")
        div(v-show="showFilters")
          el-checkbox(label='Id', name='showId', v-model='showId')
          el-checkbox(label='Επώνυμο', name='showSurname', v-model='showSurname')
          el-checkbox(label='Όνομα', name='showFirstname', v-model='showFirstname')
          el-checkbox(label='Email', name='showEmail', v-model='showEmail')
          el-checkbox(label='Τύπος Αίτησης', name='showApplicationType', v-model='showApplicationType')
          el-checkbox(label='Στάδιο Αίτησης', name='showApplicationStatus', v-model='showApplicationStatus')
          el-checkbox(label='ID απόφασης', name='showDecisionId', v-model='showDecisionId')
          el-checkbox(label='Απόφαση', name='showDecisionText', v-model='showDecisionText')
          el-checkbox(label='Ημ/νια Σταδίου', name='showStatusCreatedAt', v-model='showStatusCreatedAt')
          el-checkbox(label='Ημ/νια Κατάθεσης', name='showDateCreated', v-model='showDateCreated')
          el-checkbox(label='Ημ/νια Ολοκλ. Προελέγχου', name='showDateCompleted', v-model='showDateCompleted')
          el-checkbox(label='Αρ. πρωτοκόλλου', name='showProtocol', v-model='showProtocol')
          el-checkbox(label='Ημ/νια Πρωτοκόλλησης', name='showProtocolDate', v-model='showProtocolDate')
          el-checkbox(label='Ακαδημαϊκή περιοχή', name='showacAdemicAreaName', v-model='showacAdemicAreaName')
          hr
          //- el-checkbox(label='Δημιουργία λίστας αιτήσεων προς έλεγχο (auditing) ', name='show Audit', v-model='showAudit' @change="toggleShowAudit")
        hr
        template
        div(v-show="showAudit" v-loading="gettingAuditedApps") Προσθήκη-Αφαίρεση Αιτήσεων σε Λίστα Ελέγχου
          el-transfer(
            v-loading="submitingAuditList"
            :titles="['Προς ανάθεση', 'Αιτήσεις που εχουν ανατεθεί']",
            :button-texts="['τέλος Ελέγχου', 'προς Έλεγχο']"
            v-model='auditApplications'
            :data='allAuditedApps'
            :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }"
            @change="submitAuditList"
            @left-check-change="appsToAuditChanged"
            @right-check-change="appsToReleaseAuditChanged")
        hr(v-show="showAudit")
        el-table(
          ref="filterTable"
          stripe border highlight-current-row
          :data='tableData'
          v-loading='loadingSearchedApplications'
          @row-dblclick="loadApp"
          :default-sort = "{prop: 'dateCreated', order: 'descending'}")
          el-table-column(label='Για Έλεγχο' fixed='left' width='100' v-if="showAudit")
            template(slot-scope='scope')
              el-button(
                type="text" round size="mini"
                @click="appClicked=scope.row, addToAuditList(appClicked)"
                :disabled="isAudited(scope.row.id)"
              ) Έλεγχος
          el-table-column(v-if="showId" prop="id" label="id" width="60px" sortable='')
          el-table-column(v-if="showSurname" prop="surname" label="Επώνυμο" sortable='')
          el-table-column(v-if="showFirstname" prop="firstname" label="Όνομα" sortable='')
          el-table-column(v-if="showEmail" prop="email" label="E-mail" sortable='')
          el-table-column(
            v-if="showApplicationType"
            prop="applicationType"
            width="210px" label="Τύπος Αίτησης" sortable=''
            :filters="filterAppType"
            :filter-method="filterHandler"
          )
          el-table-column(
            v-if="showApplicationStatus"
            prop="applicationStatus" label="Στάδιο Αίτησης" sortable=''
            :filters="filterAppStatus"
            :filter-method="filterHandler"
          )
          el-table-column(v-if="showDecisionId" prop="decisionId" label="ID απόφασης" sortable='')
          el-table-column(v-if="showDecisionText" prop="decisionText" label="Απόφαση" sortable='')
          el-table-column(v-if="showStatusCreatedAt" prop="statusCreatedAt" label="Ημ/νια Σταδίου" sortable='')
          el-table-column(v-if="showDateCreated" prop="dateCreated" label="Ημ/νια Κατάθεσης" sortable='')
          el-table-column(v-if="showDateCompleted" prop="dateCompleted" label="Ημ/νια Ολοκλ. Προελέγχου" sortable='')
          el-table-column(v-if="showProtocol" prop="protocol" label="Αρ. Πρωτ." sortable='')
          el-table-column(v-if="showProtocolDate" prop="protocolDate" label="Ημ/νια Πρωτ." sortable='')
          el-table-column(
            v-if="showacAdemicAreaName"
            prop="academicAreaName" label="Ακαδ. Περιοχή" sortable=''
            :filters="filterAcademicAreaName"
            :filter-method="filterHandler"
          )
          el-table-column(
            v-if='["Admin", "President", "VicePresidentA", "VicePresidentB"].includes(activeRole)'
            prop="stepUserOrBoard"
            label="Υπάλληλος Σταδίου" sortable=''
          )
        p(style='font-size:75%') Αιτήσεις {{this.searchedApps.from}} έως {{this.searchedApps.to}}
        el-pagination(
          hide-on-single-page='true',
          prev-text="Προηγούμενο",
          next-text="Επόμενο",
          @current-change="handleCurrentChange",
          @size-change="handleSizeChange",
          :total="countSearchedApps",
          background='',
          :current-page.sync="currentPage",
          :page-sizes="[20, 50, 100, 200, 300, 400, 500]",
          :page-size="20",
          layout='total, sizes, prev, pager, next',
          :page-count="Math.ceil(this.searchedApps.total/this.searchedApps.per_page)"
        )
    el-dialog(:visible.sync='showDialog', width='90%', v-if='showDialog')
      el-card.box-card.bg-purple(v-loading = 'loadingSearchedApplication')
        .clearfix(slot="header")
          span(v-show='!showSearchedApplication')
            | Επιλέξτε μια αίτηση για να την δείτε αναλυτικά
          span(v-show='showSearchedApplication')
            | Αίτηση:
            span(style="font-weight: bold")  {{ searchedApplication.id }}
            span(v-show='searchedApplication.protocol !== null')
              |, Αριθμός Πρωτοκόλλου:
              span(style="font-weight: bold")  {{ searchedApplication.protocol }}
            span(v-show='searchedApplication.praxeisNo !== null')
              |, Αριθμός Πράξης:
              span(style="font-weight: bold")  {{ searchedApplication.praxeisNo }}
            span(v-show='received')
              |, Ημερομηνία Παραλαβής:
              span(style="font-weight: bold")  {{ dateReceived }}
            span(v-show='recognized')
              |, Ημερομηνία Αναγνώρισης:
              span(style="font-weight: bold")  {{ dateRecognized }}
        .text.item
          el-tabs(v-model='activeName', :stretch='true', v-if='showSearchedApplication')
            el-tab-pane(label='Προσωπικά Στοιχεία', name='first')
              personal-details(:personalDetails='searchedApplication.personalDetails')
            el-tab-pane(label='Τίτλος Σπουδών', name='second', v-if='!isReappraisal && !isPostExam')
              titles(:application='searchedApplication')
            el-tab-pane(label='Συνυποβολή Τίτλου', name='third',
              v-if='searchedApplication.degreeType === "bachelor" && searchedApplication.consideration === true && searchedApplication.applicationType !== "reappraisal"')
              title-consideration(:application='searchedApplication')
            el-tab-pane(label='Επισυναπτόμενα', name='fourth')
              attached-documents(:userComment='searchedApplication.userComment',
                :attachedDocumentsTable='attachedDocumentsTable', :appId='searchedApplication.id',
                :role='role', :neededDocuments='searchedApplication.neededDocuments'
              )
            el-tab-pane(label='Ιστορικό', name='fifth', :lazy='true')
              history-line(:applicationHistory='searchedAppHistory')
            el-tab-pane(label='Σχετική αίτηση', name='seventh', :lazy='true', v-if='isReappraisal || isPostExam')
              relevant-app(:relevantApp='searchedApplication.relevantApplication')
      div(v-if='showSearchedApplication && activeRole === "Admin"', style='float: left')
            releaseButton(
              releaseOrReroute="release",
              popoverContent=`Είστε σίγουροι ότι θέλετε να την αποδεσμεύσετε στον προέλεγχο;
                Αν ναι το σχόλιο για τον λόγο της αποδέσμευσης είναι υποχρεωτικό!`,
              tooltipContent="Η αίτηση θα επιστρέψει στον προέλεγχο",
              :releaseChecked="true",
              :workingApplicationId="searchedApplication.id",
              releaseByUser="Admin"
              @releasedDoc="releaseOk"
            )
      //- showHistoryButton(
      //-   v-if='activeRole === "Admin" || activeRole === "President"'
      //-   :history="searchedApplication.applicationHistory",
      //-   style='float: left'
      //- )
      div(v-if='showSearchedApplication && activeRole === "Admin"', style='float: right')
        releaseButton(
          releaseOrReroute="reroute",
          popoverContent=`Είστε σίγουροι ότι θέλετε να την αποδεσμεύσετε στον Χειριστή;
            Αν ναι το σχόλιο για τον λόγο της αποδέσμευσης είναι υποχρεωτικό!`,
          tooltipContent="Η αίτηση θα επιστρέψει στον Χειριστή",
          :releaseChecked="canReroute",
          :workingApplicationId="searchedApplication.id",
          releaseByUser="Admin"
          @releasedDoc="releaseOk"
        )
        //- el-tooltip(effect='dark', placement='top')
        //-   div(slot='content')
        //-     | Η αίτηση θα επιστρέψει στην
        //-     br
        //-     | ουρά εργασιών του προηγούμενου Ειδικού Εισηγητή
        //-   el-popover(placement='top' width='360' v-model='showReroute')
        //-     p Είστε σίγουροι ότι θέλετε να την αποδεσμεύσετε;
        //-       |  Αν ναι το σχόλιο για τον λόγο της αποδέσμευσης είναι υποχρεωτικό!
        //-     div(style='text-align: right; margin: 0')
        //-       el-input(placeholder="Σχόλιο Αποδέσμευσης", v-model="rerouteComment", type="textarea")
        //-       p
        //-         el-button(size='mini', type='text', @click='showReroute = false')
        //-           | Άκυρο
        //-         el-button(type='primary', size='mini', @click='releaseToProponent', :disabled='enableReroute')
        //-           | Αποστολή
        //-     el-button(slot='reference', size='mini', type='warning', @click='showReroute = true',
        //-       :disabled="canReroute")
        //-       | Αναδρομολόγηση σε Εισηγητή
      div(v-if='showRenotify')
        b Ανακοινοποίηση Πράξης
          el-upload(v-loading='uploading',
            class='upload-demo',
            ref='uploadFinalAct',
            accept='.pdf,.PDF',
            :file-list="attachments[0]",
            :http-request='addAttachment(searchedApplication.id)',
            :on-preview="handlePreview",
            :on-remove='handleRemove',
            :before-remove='handleBeforeRemove',
            :limit="1"
            action='',
            :auto-upload='true',
            :show-file-list='true')
            el-button(slot='trigger' size='small' type='primary') Άνοιγμα Αρχείου
            el-button(style='margin-left: 10px;', size='small', type='success', @click='uploadAttachment') Αποστολή Αρχείου
            div(class='el-upload__tip', slot='tip') ** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα Ανακοινοποιημένης  Πράξης
      div(v-if='showCreatePostExamAppButton')
        el-button(size='small' type='primary' @click='createPostExamApp') Δημιουργία Αίτησης μετά από εξετάσεις
</template>

<script>
import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
import PersonalDetails from './PersonalDetails'
import Titles from './Titles'
import TitleConsideration from './TitleConsideration'
import AttachedDocuments from './AttachedDocuments'
import HistoryLine from './HistoryLine'
import UserAppInfo from './UserAppInfo'
import dictionary from '../../store/dictionary'
import terms from '../../store/terms'
import config from '../../config.js'
import sharedMethods from '../common/sharedMethods.js'
import releaseButton from '../base/releaseButton'
import showHistoryButton from '../base/showHistoryButton'
import RelevantApp from '../common/RelevantApp'

// const FINAL_ACT_TYPE = 20

export default {
  components: {
    PersonalDetails,
    Titles,
    TitleConsideration,
    AttachedDocuments,
    HistoryLine,
    dictionary,
    UserAppInfo,
    terms,
    releaseButton,
    showHistoryButton,
    RelevantApp
  },
  mounted () {
    this.getDecisions()
    this.getAcademicAreas()
  },
  props: [],
  mixins: [sharedMethods],
  data () {
    return {
      rerouteComment: '',
      visible: false,
      showFilters: false,
      showId: true,
      showSurname: true,
      showFirstname: true,
      showDecisionId: false,
      showDecisionText: false,
      showEmail: true,
      showApplicationType: true,
      showApplicationStatus: true,
      showStatusCreatedAt: true,
      showDateCompleted: true,
      showDateCreated: false,
      showProtocol: false,
      showProtocolDate: true,
      showacAdemicAreaName: true,
      uploadListAttachment: [],
      attachments: {},
      fileData: {},
      fileName: {},
      uploading: false,
      creatingPostExamApp: false,
      showDialog: false,
      gettingRoles: false,
      appStates: terms.appStates,
      appTypes: terms.appTypes,
      appDistanceLearning: terms.appDistanceLearning,
      reappSubmissionStatuses: terms.reappSubmissionStatuses,
      compensatoryMeasuresTypes: terms.compensatoryMeasuresTypes,
      role: 'fromSearchedApps',
      searchAfm: '',
      searchType: '',
      searchModeOfStudy: '',
      searchSubmissionStatus: '',
      searchCompensatoryMeasures: '',
      searchDecision: '',
      searchBirthdate: '',
      searchActDateFrom: '',
      searchActDateTo: '',
      searchSubmitDateFrom: '',
      searchSubmitDateTo: '',
      searchStatus: '',
      searchRole: '',
      searchCountry: '',
      searchUniversity: '',
      searchCollege: '',
      searchFaculty: '',
      searchDepartment: '',
      searchAppNum: '',
      searchActNum: '',
      searchProtocolNum: '',
      searchSurname: '',
      searchFirstname: '',
      activeName: 'first',
      university: {id: null, name: null},
      universities: [],
      colleges: [],
      faculties: [],
      departments: [],
      gettingUniversities: false,
      disableCollege: true,
      disableFaculty: true,
      disableDepartment: true,
      disableUniversity: true,
      colFacDept: [],
      collegeFaculties: [],
      roles: [],
      currentPage: 1,
      per_page: 20,
      showAudit: false,
      auditApplications: [],
      allAuditedApps: [],
      appsToReleaseAudit: [],
      gettingAuditedApps: false,
      submitingAuditList: false
    }
  },
  methods: {
    loadAuditedApplications () {
      this.gettingAuditedApps = true
      axios.get(`${this.BASE_URL}/auditors/uid/applications/auditorW_`)
        .then((response) => {
          this.gettingAuditedApps = false
          this.auditApplications = response.data.data.map(app => app.id)
          this.allAuditedApps = response.data.data.map(app => {
            return {
              key: app.id,
              label: `${app.id}, ${app.degreeType}, ${app.surname}, ${app.name}`,
              disabled: false
            }
          })
        }, (err) => {
          this.gettingAuditedApps = false
          this.backendError(err)
        })
    },
    submitAuditList (rightListItems, dir, movedItems) {
      this.submitingAuditList = true
      this.auditApplications = rightListItems
      axios.put(`${this.BASE_URL}/auditors/applications`,
        {
          applications: this.auditApplications
        }
      ).then((response) => {
        this.submitingAuditList = false
        let op = dir === 'right' ? 'ανάθεση αιτήσεων για έλεγχο: ' : 'αποδέσμευση αιτήσεων από έλεγχο: '
        this.$notify.success({
          title: 'Ειδοποίηση',
          message: `Επιτυχής ${op} ${movedItems}`,
          offset: 100
        })
      }).catch(err => {
        this.submitingAuditList = false
        this.frontEndError('Σφάλμα κατά την ανάθεση/αποδέσμευση των αιτήσεων')
        this.backendError(err)
      })
    },
    addToAuditList (app) {
      if (!this.isAudited(app.id)) {
        this.allAuditedApps.push({
          key: app.id,
          label: `${app.id}, ${app.applicationType}, ${app.surname}, ${app.firstname}`,
          disabled: false
        })
      }
    },
    isAudited (id) {
      var valueArr = this.allAuditedApps.map(function (item) { return item.key })
      return valueArr.some((element) => element === id)
    },
    appsToReleaseAuditChanged (apps) {
      this.appsToReleaseAudit = apps
    },
    appsToAuditChanged (apps) {
      this.appsToAudit = apps
    },
    toggleShowAudit (val) {
      this.showAudit = val
      if (this.showAudit === true) {
        this.loadAuditedApplications()
      }
    },
    releaseOk () {
      this.showDialog = false
    },
    submitUpload () {
      this.$refs.uploadFinalAct.submit()
    },
    getData (file) {
      return new Promise((resolve, reject) => {
        const fReader = new FileReader()
        let base64Pdf
        fReader.onload = (fileLoadedEvent) => {
          base64Pdf = fileLoadedEvent.target.result
          resolve(base64Pdf.split(',')[1])
        }
        fReader.readAsDataURL(file)
      })
    },
    addAttachment (id) {
      return (file, fileList) => {
        if (fileList === undefined) {
          this.$set(this.attachments, id, [file.file])
        } else {
          this.attachments[id].push(file.file)
        }
        let self = this
        return self.getData(file.file).then(data => {
          self.fileData[id] = data
          self.fileName[id] = file.file.name
        })
      }
    },
    createPostExamApp () {
      const appId = this.searchedApplication.id
      const msg = `Θα δημιουργηθεί μια καινούρια αίτηση με τα αποτελέσματα των εξετάσεων της αίτησης ${appId}.`
      this.$confirm(msg,
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        this.creatingPostExamApp = true
        axios.post(`${this.BASE_URL}/externalusers/uid/applications`,
          {
            applicationType: 'compensatory',
            relevantAppId: appId
          }
        ).then((response) => {
          this.loadApp(this.searchedApplication)
          this.notifyUser('success', 'Επιτυχία', 'Η αίτηση δημιουργήθηκε με επιτυχία')
          this.creatingPostExamApp = false
        }).catch(() => {
          this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά τη δημιουργία της αίτησης')
          this.creatingPostExamApp = false
        })
      }).catch(() => {
      })
    },
    uploadAttachment () {
      this.$confirm(this.saveMessage(this.searchedApplication),
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        this.uploading = true
        axios.post(`${this.BASE_URL}/presidents/${this.currentUser.id}/applications/${this.searchedApplication.id}/renotification`,
          {
            judgment: {
              file: this.fileData[this.searchedApplication.id], // Το τελικο αρχείο προς ψηφιακή υπογραφή σε base64
              name: this.fileName[this.searchedApplication.id] // Το όνομα του αρχείου
            }
          }
        ).then((response) => {
          this.loadApp(this.searchedApplication)
          this.notifyUser('success', 'Επιτυχία', 'Η αίτηση προωθήθηκε με επιτυχία')
          this.uploading = false
        }).catch(() => {
          this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποστολή του αρχείου')
          this.uploading = false
        })
      }).catch(() => {
      })
    },
    saveMessage (assignedApp) {
      return 'Θέλετε να αποστείλετε την ψηφιακά υπογεγραμμένη πράξη του Αρ. Πρ. Φακέλου ' +
      this.searchedApplication.protocol + ' και να ενημερωθεί o χρήστης ' +
      this.searchedApplication.personalDetails.name + ' ' + this.searchedApplication.personalDetails.surname + ';'
    },
    notifyUser (type, title, msg) {
      if (type === 'success') {
        this.$notify.success({
          title: title,
          message: msg
        })
      } else {
        this.$notify.error({
          title: title,
          message: msg
        })
      }
    },
    handleRemove (file, fileList) {
      // const url = `${this.BASE_URL}/presidents/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments/${file.id}`
      // return axios.delete(url
      // }).then(response => {
      //   this.$store.dispatch('SET_PRECHECKER_ATTACHMENTS', this.precheckerAttachments.filter(attachment => attachment.id !== file.id))
      // }).catch(err => this.catchError(err))
    },
    handlePreview (file) {
      this.$notify.warning({
        title: 'Ειδοποίηση',
        message: 'Για να δείτε το αρχείο πηγαίνετε στην καρτέλα Επισυναπτόμενα',
        offset: 100
      })
      const base64Data = encodeURI(this.fileData[this.searchedApplication.id])
      this.openPdfWindow(file.name + ' (' + file.id + ')', base64Data)
    },
    handleBeforeRemove (file, fileList) {
      return this.$confirm(`Να αφαιρεθεί το ${file.name} από την λίστα μεταφόρτωσης αρχείου？`)
    },
    getDecisions () {
      this.$store.dispatch('LOAD_PRESIDENT_DECISIONS')
    },
    getAcademicAreas () {
      this.$store.dispatch('LOAD_ACADEMIC_AREAS')
    },
    getRoles () {
      if (this.roles.length === 0) {
        this.gettingRoles = true
        axios.get(`${this.BASE_URL}/roles`).then((response) => {
          this.roles = response.data.data
          this.gettingRoles = false
        }, (err) => {
          this.roles = []
          this.gettingRoles = false
          this.backendError(err)
        })
      }
    },
    getFacultiesCollegesDepartments (country, university) {
      axios.get(`${config.BASE_URL}/countries/${country}/universities/${university}`)
        .then((response) => {
          // all {colleges:[] {faculties:[] {departments:[]}}, Faculties:[] {departments:[]}} for university
          this.colFacDept = response.data.data
          // get the university colleges:[{faculties:[{departments[]},...]},...]
          this.colleges = this.colFacDept.colleges
          // get the university faculties: [{departments[]},...]
          this.faculties = this.colFacDept.faculties
          this.disableCollege = false
          this.disableFaculty = false
        })
    },
    facultySelected (faculty) {
      this.searchDepartment = ''
      this.departments = []
      if (faculty !== '') {
        this.colFacDepartments = this.collegeFaculties
          ? this.collegeFaculties.find(fac => fac.id === faculty).departments
          : [{id: 0, name: 'δεν βρέθηκε'}]
        this.departments = this.colFacDepartments
        this.disableDepartment = false
      } else {
        this.disableDepartment = true
      }
    },
    collegeSelected (college) {
      this.searchFaculty = ''
      this.searchDepartment = ''
      this.departments = []
      this.faculties = []
      if (college !== '') {
        this.collegeFaculties = this.colleges
          ? this.colleges.find(col => col.id === college).faculties
          : [{ id: 0, name: 'δεν βρέθηκε' }]
        this.faculties = this.collegeFaculties
      } else {
        this.disableDepartment = true
      }
    },
    universitySelected (university) {
      this.initializeColFacDep()
      this.disableCollege = true
      this.disableFaculty = true
      this.disableDepartment = true
      if (university !== '') {
        this.getFacultiesCollegesDepartments(this.searchCountry, university)
      }
    },
    countrySelected (country) {
      this.university = {id: null, name: null}
      this.initializeColFacDep()
      this.disableCollege = true
      this.disableFaculty = true
      this.disableDepartment = true
      this.searchUniversity = ''
      if (country !== '') {
        this.gettingUniversities = true
        axios.get(`${config.BASE_URL}/countries/${country}/universities`)
          .then((response) => {
            this.universities = response.data.data
            this.disableUniversity = false
            this.gettingUniversities = false
          }).catch(err => {
            this.backendError(err)
            this.disableUniversity = false
            this.gettingUniversities = false
            this.searchUniversity = ''
            this.universities = []
          })
      } else {
        this.searchUniversity = ''
        this.universities = []
        this.disableUniversity = true
      }
    },
    initializeColFacDep () {
      this.searchFaculty = ''
      this.searchDepartment = ''
      this.searchCollege = ''
      this.colleges = []
      this.colFacDept = []
      this.collegeFaculties = []
      this.colFacDepartments = []
      this.faculties = []
      this.departments = []
    },
    filterHandler (value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    toggleSearch () {
      this.$store.dispatch('SHOW_HIDE_APPSEARCH')
    },
    loadApp (val) {
      this.$store.dispatch('LOAD_SEARCHED_APPLICATION', val.id)
      this.showDialog = true
    },
    searchApps () {
      this.$store.dispatch('LOAD_SEARCHED_APPS',
        {
          decision: this.searchDecision,
          birthDate: this.searchBirthdate === null ? '' : this.searchBirthdate.substring(0, 5),
          actdate_from: this.searchActDateFrom === null ? '' : this.searchActDateFrom,
          actdate_to: this.searchActDateTo === null ? '' : this.searchActDateTo,
          submit_from: this.searchSubmitDateFrom === null ? '' : this.searchSubmitDateFrom,
          submit_to: this.searchSubmitDateTo === null ? '' : this.searchSubmitDateTo,
          status: this.searchStatus,
          role: this.searchRole,
          country: this.searchCountry,
          university: this.searchUniversity,
          college: this.searchCollege,
          faculty: this.searchFaculty,
          department: this.searchDepartment,
          afm: this.searchAfm,
          surname: this.searchSurname,
          firstname: this.searchFirstname,
          app_id: this.searchAppNum,
          act: this.searchActNum,
          protocol: this.searchProtocolNum,
          type: this.searchType,
          distant: this.searchModeOfStudy,
          overdue: this.searchSubmissionStatus,
          compensatory: this.searchCompensatoryMeasures,
          page: this.currentPage,
          per_page: this.per_page
        })
    },
    handleSearchPage () {
      this.currentPage = 1
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.searchApps()
    },
    handleSizeChange (val) {
      this.per_page = val
      this.searchApps()
    },
    releaseToProponent () {
      this.visible = false
      this.$confirm('Η αίτηση θα δρομολογηθεί πίσω στον Χειριστή',
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        axios.post(`${this.BASE_URL}/users/userId/applications/${this.searchedApplication.id}/reroute`,
          {
            releaseData: {
              rerouteComment: this.rerouteComment
            }
          }
        ).then((response) => {
          this.showDialog = false
          this.$notify.success({
            title: 'Ειδοποίηση',
            message: 'Η αίτηση αποδεσμεύτηκε με επιτυχία',
            offset: 100
          })
        }).catch((err) => {
          this.showDialog = false
          this.backendError(err)
          this.$notify.error({
            title: 'Ειδοποίηση',
            message: 'Σφάλμα κατά την αποδέσμευση της αίτησης',
            offset: 100
          })
        })
        this.searchApps()
      })
    }
  },
  computed: {
    isPostExam () {
      return this.searchedApplication.applicationType === 'compensatory'
    },
    isReappraisal () {
      return this.searchedApplication.applicationType === 'reappraisal'
    },
    showStepUserOrBoard () {
      return ['Admin', 'President', 'VicePresidentA', 'VicePresidentB'].includes(this.activeRole)
    },
    canReroute () {
      const history = this.searchedApplication.applicationHistory

      return history &&
        history.length > 5 &&
        history.find(step => step.applicationStatus === 'proponentW_President') &&
        this.last(history).applicationStatus !== 'proponentW_Admin'
    },
    enableReroute () {
      return this.rerouteComment.length < 5
    },
    hasPraxi () {
      const allowedDocTypes = [20]
      const lastDocument = this.searchedApplication.attachedDocuments.slice(-1)[0]
      const result = allowedDocTypes.includes(lastDocument.type)
      return result
    },
    showCreatePostExamAppButton () {
      return this.activeRole === 'PreChecker' && this.searchedApplication.isEligibleForCompensatoryAutoApp
    },
    showRenotify () {
      const history = this.searchedApplication.applicationHistory
      return this.activeRole === 'President' &&
        history &&
        this.last(history).applicationStatus === 'president_finalized' &&
        this.hasPraxi
    },
    dateRecognized () {
      const history = this.searchedApplication.applicationHistory

      const step = history && this.last(history)

      return step &&
        step.date !== null &&
        step.applicationStatus === 'president_finalized'
        ? step.date.substring(0, 10) : '-'
    },
    recognized () {
      const history = this.searchedApplication.applicationHistory

      const step = history && this.last(history)

      return step &&
        step.date !== null &&
        step.applicationStatus === 'president_finalized'
        ? step.date !== null : false
    },
    dateReceived () {
      const history = this.searchedApplication.applicationHistory

      const step = history && this.last(history)

      return step &&
        step.dateCompleted !== null &&
        step.applicationStatus === 'president_finalized'
        ? step.dateCompleted.substring(0, 10) : '-'
    },
    received () {
      const history = this.searchedApplication.applicationHistory

      const step = history && this.last(history)

      return step &&
        step.dateCompleted !== null &&
        step.applicationStatus === 'president_finalized'
    },
    filterAppStatus () {
      return [ {text: 'Εξωτερικός Χρήστης', value: 'Εξωτερικός Χρήστης'},
        {value: 'Προέλεγχος', text: 'Προέλεγχος'},
        {value: 'Χειριστής από Πρόεδρο', text: 'Χειριστής από Πρόεδρο'},
        {value: 'Ειδικός εισηγητής από Εκτελεστική επιτροπή', text: 'Ειδικός εισηγητής από Εκτελεστική επιτροπή'},
        {value: 'Έλεγχος από Χειριστή', text: 'Έλεγχος από Χειριστή'},
        {value: 'Έλεγχος από Αντιπρόεδρο', text: 'Έλεγχος από Αντιπρόεδρο'},
        {value: 'Έλεγχος από Εκτελεστική επιτροπή', text: 'Έλεγχος από Εκτελεστική επιτροπή'},
        {value: 'Αντιπρόεδρος από Πρόεδρο', text: 'Αντιπρόεδρος από Πρόεδρο'},
        {value: 'Εκτελεστική επιτροπή από Πρόεδρο', text: 'Εκτελεστική επιτροπή από Πρόεδρο'},
        {value: 'Εκτελεστική επιτροπή από Εισηγητή', text: 'Εκτελεστική επιτροπή από Εισηγητή'},
        {value: 'Εκτελεστική επιτροπή από Ακαδημαϊκό', text: 'Εκτελεστική επιτροπή από Ακαδημαϊκό'},
        {value: 'Πρόεδρος από Προέλεγχο', text: 'Πρόεδρος από Προέλεγχο'},
        {value: 'Καταχωρητής Απόφασης_', text: 'Καταχωρητής Απόφασης'},
        {value: 'Ουρά προελέγχου', text: 'Ουρά προελέγχου'},
        {value: 'Πρόεδρος από Καταχωρητή', text: 'Πρόεδρος από Καταχωρητή'},
        {value: 'Ολοκληρωμένη-Παραλαβή', text: 'Ολοκληρωμένη-Παραλαβή'},
        {value: 'Αξιολογητής από Χειριστή', text: 'Αξιολογητής από Χειριστή'},
        {value: 'Πρόεδρος', text: 'Πρόεδρος'},
        {value: 'Εκτελεστική επιτροπή', text: 'Εκτελεστική επιτροπή'},
        {value: 'Ουρά καταχωρητών', text: 'Ουρά καταχωρητών'}]
    },
    filterAcademicAreaName () {
      let filterAcademicAreas = this.academicAreas.map(ac => {
        let area = ac
        area.value = ac.name
        area.text = ac.name
        return area
      })
      return filterAcademicAreas
    },
    filterAppType () {
      return [ {text: 'ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ 1ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ', value: 'ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ 1ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ'},
        {text: 'ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ 1ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ ΜΕ ΣΥΝΥΠΟΒΟΛΗ ΤΙΤΛΟΥ 2ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ', value: 'ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ 1ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ ΜΕ ΣΥΝΥΠΟΒΟΛΗ ΤΙΤΛΟΥ 2ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ'},
        {text: 'ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ 2ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ', value: 'ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ 2ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ'},
        {text: 'ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ 3ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ', value: 'ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ 3ου ΚΥΚΛΟΥ ΣΠΟΥΔΩΝ'}]
    },
    tableData () {
      if (this.searchedApps.length === 0) {
        return []
      } else {
        return this.searchedApps.map(app => {
          return {
            afm: app.afm,
            applicationStatus: dictionary[app.applicationStatus] ? dictionary[app.applicationStatus] : '',
            applicationType: dictionary[app.applicationType] ? dictionary[app.applicationType] : app.applicationType,
            dateCompleted: app.dateCompleted,
            dateCreated: app.dateCreated ? app.dateCreated.substring(0, 10) : '',
            statusCreatedAt: app.statusCreatedAt ? app.statusCreatedAt.substring(0, 10) : '',
            id: app.id,
            firstname: app.firstname,
            surname: app.surname,
            email: app.email,
            protocol: app.protocol,
            protocolDate: app.protocolDate ? app.protocolDate.substring(0, 10) : '',
            academicAreaName: app.academicAreaName,
            stepUserOrBoard: app.stepUserOrBoard,
            decisionId: app.decision_id,
            decisionText: app.decision_text
          }
        })
      }
    },
    countSearchedApps () {
      return this.searchedApps && this.searchedApps.length
    },
    attachedDocumentsTable () {
      return this.searchedApplication.attachedDocuments.slice(0).map(doc =>
        ({name: doc.name,
          type: doc.type,
          date: doc.date,
          applicantComment: doc.applicantComment,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          id: doc.id
        })
      )
    },
    ...mapGetters(['activeRole', 'currentUser']),
    ...mapState([
      'searchedApps',
      'workingApplication',
      'showSearchedApplication',
      'searchedApplication',
      'loadingSearchedApplication',
      'loadingSearchedApplications',
      'searchedAppHistory',
      'BASE_URL',
      'countries',
      'presidentDecisions',
      'loadingPresidentDecisions',
      'academicAreas'
    ])
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.el-select {
    &.big {
      width: 440px;
    }
    &.biggest {
      width: 1100px;
    }
    &.countries {
      width: 440px;
    }
  }
  .searchButton {
    margin-left: 30px
  }
  .el-input {
    width: 200px
  }
</style>



// WEBPACK FOOTER //
// src/components/common/ApplicationSearch.vue